// Local translations
export const T = {
  en_GB: {
    title: "Trapets PEP / sanction screening",
    description: "Choose how Trapets PEP/sanction screening runs for your organization",
    mode: "Mode",
    disabled: "Disabled",
    test: "Test",
    production: "Production",
    usingDisabled: "Screening is turned off for your organization",
    usingTestCreds: "Using the shared sandbox environment",
    usingProdCreds: "Using the production environment",
    failedToSave: "Failed to save settings",
    settingsSaved: "Saved",
    pricesFootnote: "Prices apply to production usage only. Test mode is free.",
  },
  nb_NO: {
    title: "Trapets PEP-/sanksjonskontroll",
    description: "Velg hvordan Trapets PEP-/sanksjonskontroll kjører for organisasjonen din",
    mode: "Modus",
    disabled: "Deaktivert",
    test: "Test",
    production: "Produksjon",
    usingDisabled: "Kontroll er slått av for organisasjonen din",
    usingTestCreds: "Bruker det delte sandkassemiljøet",
    usingProdCreds: "Bruker produksjonsmiljøet",
    failedToSave: "Kunne ikke lagre innstillinger",
    settingsSaved: "Lagret",
    pricesFootnote: "Priser gjelder kun produksjonsbruk. Testmodus er gratis.",
  },
} as const;
